import React from 'react';
import { Container } from './Container';
import { SectionHeading } from './SectionHeading';
import { benefits } from '../data/content';
export function FuturePaced() {
  return <section aria-labelledby="future-heading" className="bg-paper py-16 sm:py-24" data-id="element-73" data-mp="14ud3ieq0ulg6">
      <Container narrow data-id="element-74" data-mp="14w7qdykusnmw">
        <SectionHeading id="future-heading" title="Imagine What Your Afternoons Will Look Like…" data-id="element-75" data-mp="10t1kis1nkygy" />

        <ul className="mx-auto mt-11 grid max-w-[760px] gap-3.5 sm:mt-14 sm:gap-4" data-id="element-76" data-mp="vuqb2if9spz9">
          {benefits.map(benefit => <li key={benefit.lead} className="flex items-start gap-3.5 rounded-card border border-hairline bg-white p-5 shadow-paper sm:gap-4 sm:p-6" data-id="element-77" data-mp="r1nj2eq55ol6">
              {/* mirror of the pain section's mark, in green */}
              <span aria-hidden="true" className="mt-[7px] flex h-3.5 w-3.5 flex-none items-center justify-center rounded-full bg-goSoft sm:mt-[9px]" data-id="element-78" data-mp="d3gtdlvciuwl">
                <span className="h-1.5 w-1.5 rounded-full bg-goDark" data-id="element-79" data-mp="35iby45apgjau" />
              </span>

              <p data-id="element-80" data-mp="3a9tyar4wmfur">
                <span className="font-display text-[18px] font-extrabold leading-[1.22] tracking-[-0.01em] text-ink sm:text-[21px]" data-id="element-81" data-mp="3aac3id9jo4et">
                  {benefit.lead}
                </span>
                {benefit.rest && <span className="mt-1.5 block text-[15px] font-semibold leading-[1.45] text-muted sm:text-[16px]" data-id="element-82" data-mp="30jqxi4rjjxlv">
                    {benefit.rest}
                  </span>}
              </p>
            </li>)}
        </ul>

        <blockquote className="relative mt-11 overflow-hidden rounded-xl2 bg-ink px-6 py-9 text-center sm:mt-14 sm:px-12 sm:py-12" data-id="element-83" data-mp="3f8wyny9xvxwe">
          <p className="mx-auto max-w-[660px] font-display text-[22px] font-extrabold leading-[1.25] tracking-[-0.015em] text-white sm:text-[30px]" data-id="element-84" data-mp="3k5x17z7kyiir">
            Because in the world they’re growing into, consuming information won’t be enough.
            <span className="mt-5 block text-sun" data-id="element-85" data-mp="ec36m3hxf45k">
              The advantage will belong to those who can imagine, create and turn an idea into
              something real.
            </span>
          </p>
        </blockquote>
      </Container>
    </section>;
}